import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Fragment } from "react";
import { Controller } from "react-hook-form";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

export const DispatchForm = ({ form }) => {
	const {
		control,
		formState: { errors },
	} = form;

	return (
		<Fragment>
			<Box my={3}>
				<Controller
					name={`tracking_url`}
					rules={{
						required: "Tracking URL Required",
					}}
					control={control}
					defaultValue={null}
					render={({ field }) => (
						<TextField
							{...field}
							value={field.value ?? null}
							fullWidth
							label="Tracking URL"
							variant="outlined"
							error={Boolean(errors.tracking_number)}
							helperText={errors.tracking_number?.message}
						/>
					)}
				/>
			</Box>
			<Box my={3}>
				<Controller
					name={`tracking_number`}
					rules={{
						required: "Tracking Number Required",
					}}
					control={control}
					defaultValue={null}
					render={({ field }) => (
						<TextField
							{...field}
							value={field.value ?? null}
							fullWidth
							label="Tracking Number"
							variant="outlined"
							error={Boolean(errors.tracking_number)}
							helperText={errors.tracking_number?.message}
						/>
					)}
				/>

				{/* <TextField
					// InputLabelProps={{ shrink: true }}
					{...register("tracking_number", {
						register: "Tracking ID Required",
					})}
					fullWidth
					label="Tracking Number"
					variant="outlined"
					multiline
					minRows={1}
					// value={brand.name}
					error={Boolean(errors.tracking_number)}
					helperText={errors.tracking_number?.message}
				/> */}
			</Box>
			<LocalizationProvider dateAdapter={AdapterMoment}>
				<Box sx={{ display: "flex", gap: 2, mt: 2 }}>
					{/* Start Date */}
					<Controller
						name={`estimated_arrival_date`}
						control={control}
						rules={{
							required: "Estimated Date of Arrival required",
						}}
						render={({ field }) => (
							<DatePicker
								label="Estimated Date of Arrival"
								inputFormat="DD/MM/YYYY"
								minDate={moment()}
								{...field}
								value={field.value ?? null}
								renderInput={(params) => (
									<TextField
										fullWidth
										{...params}
										error={!!errors?.estimated_arrival_date}
										helperText={
											errors.estimated_arrival_date
												?.message
										}
									/>
								)}
							/>
						)}
					/>
				</Box>
			</LocalizationProvider>
		</Fragment>
	);
};
